const pdfStyle = {
  bgcolor: "background.paper",
  borderRadius: "xl",
  p: { xs: 3, md: 5 },
  boxShadow: "0 6px 18px rgba(14, 22, 29, 0.08)",
  maxWidth: 900,
  mx: "auto",
  color: "text.primary",
  fontFamily: "inherit",
};

const invoiceTableStyle = {
  border: "1px solid #444",
  "& td, & th": {
    border: "1px solid #444",
    padding: "3px 6px",
    fontSize: "12px",
  },
  "& th": {
    fontWeight: "bold",
    textAlign: "center",
    color: "#2b2b2b",
    backgroundColor: "#f4f4f4",
  },
  "& td": {
    textAlign: "center",
  },
  "& .title-cell": {
    fontWeight: 500,
  },
  "& .value-cell": {
    color: "#344767",
  },
};

export { pdfStyle, invoiceTableStyle };